import { Component, ViewEncapsulation } from '@angular/core';
import '@omnitracs/footer-component';

@Component({
  selector: 'ot-footer-component',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FooterComponent {}
